import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import InputField from '../forms/InputField';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LoaderModal from './loaderModal';
import { errorToast, successToast } from '../toast';
import { forgotPasswordAction } from '../../redux/actions/authAction';

const ForgotPasswordModal = ({ toggleModal }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const initialValues = {
        email: '',
    };

    const validationSchema = Yup.object({
        email: Yup.string().email('Invalid email format').required('Email is required'),
    });

    const handleSubmit = (values, { setSubmitting }) => {

        setLoading(true);
        const dispatchingValues = {
            email: values.email
        }
        dispatch(forgotPasswordAction(dispatchingValues, onSuccess, onError))
        setSubmitting(false);
    };

    const onSuccess = (data) => {
        successToast(data.data.message);
        setLoading(false);
        toggleModal()
    };
    const onError = (data) => {
        setLoading(false);
        errorToast(data.data.message);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 text-black">
            <div className="bg-white shadow-lg rounded-lg px-8 pt-6 pb-8 w-96">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-heading font-bold text-primary">Forgot Password</h2>
                    <button onClick={toggleModal} className="text-4xl text-gray-500 hover:text-gray-800">
                        ×
                    </button>
                </div>

                <p className="text-sm text-gray-600 mb-4">
                    Enter your registered email address, and we’ll send you a link to reset your password.
                </p>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    <Form>
                        <InputField
                            label="Email"
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                        />
                        <button
                            type="submit"
                            className="w-full bg-primary text-white py-2 px-4 rounded-lg hover:bg-primary-hover mt-4"
                        >
                            Send Reset Link
                        </button>
                    </Form>
                </Formik>
            </div>
            {loading && <LoaderModal />}
        </div>
    );
};

export default ForgotPasswordModal